// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Link from "@insite/mobius/Link";
import { LinkPresentationProps } from "@insite/mobius/Link/Link";
import Typography from "@insite/mobius/Typography";
import { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = {
    title?: string;
    linkTitle?: string;
    onLinkClick?: React.EventHandler<React.MouseEvent>;
};

export interface StoreCheckoutInformationBoxStyles {
    wrapper?: InjectableCss;
    header?: InjectableCss;
    body?: InjectableCss;
    bodySection?: InjectableCss;
    title?: TypographyPresentationProps;
    link?: LinkPresentationProps;
}

export const storeCheckoutInformationBoxStyles: StoreCheckoutInformationBoxStyles = {
    wrapper: {
        css: css`
            background-color: ${getColor("common.accent")};
        `,
    },
    header: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 1.25em;

            @media print {
                padding-left: 0;
            }
        `,
    },
    body: {
        css: css`
            padding: 2em 1.4em;
            background-color: ${getColor("common.background")};
            border: ${pxToRem(8)} solid ${getColor("common.accent")};
            border-top: none;

            @media print {
                padding: 0;
                border: none;
            }
        `,
    },
    title: {
        css: css`
            margin-bottom: 0;
        `,
    },
    bodySection: {
        css: css``,
    },
};

const styles = storeCheckoutInformationBoxStyles;

const StoreCheckoutInformationBox: FC<Props> = ({ title, linkTitle, onLinkClick, children }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.header}>
                {title && (
                    <Typography as="h2" variant="h4" {...styles.title}>
                        {title}
                    </Typography>
                )}
                {linkTitle && onLinkClick && (
                    <Link onClick={onLinkClick} {...styles.link}>
                        {linkTitle}
                    </Link>
                )}
            </StyledWrapper>
            <StyledWrapper {...styles.body}>
                <StyledWrapper {...styles.bodySection}>{children}</StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default StoreCheckoutInformationBox;
